// Badge de una norma: ISO en azul (b-info), el resto (BPADIS, reglamentos) en ámbar
// (b-warn). Una sola regla para la ficha, la Lista Maestra y Configuración › Catálogos.

export function normBadgeClass(normCode: string): 'b-info' | 'b-warn' {
  return normCode.toUpperCase().includes('ISO') ? 'b-info' : 'b-warn';
}
